const heroSwiper = new Swiper('#heroSwiper', {
    loop: true,
    speed: 2000,
    effect: 'fade',
    grabCursor: true,
    allowTouchMove: true,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false
    },
    fadeEffect: {
        crossFade: true
    },
    pagination: {
        el: '#heroSwiper .hero-pagination',
        clickable: true
    }
});
/*
function updateProgressBar(activeIndex) {
    const allProgress = document.querySelectorAll('.progress-bar__progress');
    const total = 100;
    allProgress.forEach((circle, index) => {
        if (index === activeIndex) {
            // 進捗アニメーション
            circle.style.transition = 'none';
            circle.style.strokeDashoffset = total;
            // 少し遅延してアニメ開始
            setTimeout(() => {
                circle.style.transition = 'stroke-dashoffset 5s linear';
                circle.style.strokeDashoffset = 0;
            }, 50);
        } else {
            // 他はリセット
            circle.style.transition = 'none';
            circle.style.strokeDashoffset = total;
        }
    });
}
*/


/*

const mainSwiper = new Swiper('.thum-swiper', {
    loop: true,
    speed: 1000,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false
    },
    on: {
        slideChangeTransitionStart: function () {
            updateProgressBar(this.realIndex);
        },
        init: function () {
            updateProgressBar(this.realIndex);
        }
    }
});

function updateProgressBar(activeIndex) {
    const allProgress = document.querySelectorAll('.progress-bar__progress');
    const total = 100;
    allProgress.forEach((circle, index) => {
        if (index === activeIndex) {
            // 進捗アニメーション
            circle.style.transition = 'none';
            circle.style.strokeDashoffset = total;
            // 少し遅延してアニメ開始
            setTimeout(() => {
                circle.style.transition = 'stroke-dashoffset 5s linear';
                circle.style.strokeDashoffset = 0;
            }, 50);
        } else {
            // 他はリセット
            circle.style.transition = 'none';
            circle.style.strokeDashoffset = total;
        }
    });
}



const mainSwiper = new Swiper('#heroSwiper', {
  loop: true,
  effect: 'fade',
  speed: 1000,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false
  },
  thumbs: {
    swiper: thumbSwiper
  }
});

*/
                             